import React, { useContext, Fragment } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { store as mainStore } from '../../../../store';
import Admin from './Admin/Admin';
import useTitle from 'hooks/useTitle';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    '& > *:not(:last-child)': {
      marginBottom: theme.spacing(1),
    },
  },
}));
const Dashboard = () => {
  useTitle("داشبورد")
  const classes = useStyles();
  const {
    state: {
      Auth: {
        profile: { username },
      },
    },
  } = useContext(mainStore);
  return (
    <div className={classes.root}>
      <Admin />
    </div>
  );
};

export default React.memo(Dashboard);
